import { useTranslation } from "react-i18next";
import { supportedLanguages } from "@/i18n";

export default function LanguageSelector({ compact = false }) {
  const { i18n, t } = useTranslation();
  const currentLanguage = (i18n.resolvedLanguage || "en").split("-")[0];
  return (
    <label className={compact ? "block" : "block px-4 pb-3"}>
      <span className="sr-only">{t("language")}</span>
      <select value={currentLanguage} onChange={(event) => i18n.changeLanguage(event.target.value)} aria-label={t("language")} data-testid="language-selector" className={["w-full rounded-sm border bg-transparent text-sm outline-none", "focus:border-[#C5A059] focus:ring-1 focus:ring-[#C5A059]", compact ? "h-9 border-slate-300 px-2 text-[#0B2545]" : "h-10 border-white/20 px-3 text-white"].join(" ")}>
        {supportedLanguages.map((language) => <option key={language.code} value={language.code} className="bg-white text-[#0B2545]">{language.label}</option>)}
      </select>
    </label>
  );
}
